// =============================================================================
// "My label" per shared calendar.
//
// In a shared calendar every member picks a label colour for the events they
// create (shared_calendar_members.category_id). The lock-screen widget needs
// it to break ties: when two events start at the same time, the one carrying
// *my* label is the one worth showing. Members are not part of `data` (they
// come from an RPC), so the app refreshes this small map on load and the
// widget bridge reads it synchronously, like the language and theme.
// =============================================================================

import { listSharedCalendarMembers } from './sharedCalendars';

const KEY = 'eulea_my_labels';

const read = () => {
  try {
    const raw = window.localStorage.getItem(KEY);
    const obj = raw ? JSON.parse(raw) : {};
    return obj && typeof obj === 'object' ? obj : {};
  } catch {
    return {};
  }
};

const write = (map) => {
  try {
    window.localStorage.setItem(KEY, JSON.stringify(map));
  } catch {
    // best effort
  }
};

export const myLabelFor = (calendarId) => read()[calendarId] || null;

export const rememberMyLabel = (calendarId, categoryId) => {
  if (!calendarId) return;
  const map = read();
  if (categoryId) map[calendarId] = categoryId;
  else delete map[calendarId];
  write(map);
};

// Fetch my label in every shared calendar the user is in. Returns true when
// something changed, so the caller can push a fresh widget snapshot.
export const refreshMyLabels = async (sharedCalendars, userId) => {
  if (!userId) return false;
  const before = JSON.stringify(read());
  await Promise.all(
    (sharedCalendars || []).map(async (cal) => {
      try {
        const members = await listSharedCalendarMembers(cal.id);
        const me = members.find((m) => m.userId === userId);
        rememberMyLabel(cal.id, me ? me.categoryId : null);
      } catch {
        // keep whatever we had
      }
    })
  );
  return JSON.stringify(read()) !== before;
};
